import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "el",
  class: "md:relative z-10 ml-3 md:ml-0 md:mr-3"
}
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "font-robotoBold text-lg" }, "Notifications", -1)
const _hoisted_5 = { class: "relative cursor-pointer text-cebai-grey-dark hover:text-cebai-base-dark" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, " Unread Only ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "my-3 border-cebai-grey-light" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "block text-center md:text-right mb-3"
}
const _hoisted_9 = {
  key: 1,
  class: "h-full text-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "No New Notifications", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "block text-lg" }
const _hoisted_14 = { class: "block mb-1" }
const _hoisted_15 = { class: "block text-xs text-cebai-grey-dark uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationsIcon = _resolveComponent("NotificationsIcon")!

  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "block",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleOpenState && _ctx.toggleOpenState(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_NotificationsIcon, {
              class: _normalizeClass({ 'text-cebai-grey-mid fill-current': _ctx.totalUnread > 0 })
            }, null, 8, ["class"]),
            _createElementVNode("div", {
              class: _normalizeClass(["absolute -right-2 top-0 px-2 py-1 text-xs font-robotoBold leading-none rounded-full", {
            'bg-cebai-grey-light text-cebai-grey-dark': _ctx.totalUnread === 0,
            'bg-cebai-primary text-cebai-grey-lightest': _ctx.totalUnread > 0,
          }])
            }, _toDisplayString(_ctx.totalUnread), 3)
          ])
        ]),
        (_ctx.notifications)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["absolute z-10 w-80 md:w-96 max-h-80 py-3 px-5 left-0 right-0 md:left-auto md:top-full bg-cebai-grey-lightest border-2 border-cebai-grey-light rounded-xl text-left text-cebai-base-dark duration-300 transition-all overflow-y-scroll", {
        'mt-2 visible opacity-100': _ctx.isOpen,
        '-mt-2 invisible opacity-0': !_ctx.isOpen,
      }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("label", _hoisted_5, [
                  _hoisted_6,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toggleUnread) = $event)),
                    type: "checkbox",
                    class: "ml-1 cursor-pointer"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.toggleUnread]
                  ])
                ])
              ]),
              _hoisted_7,
              (_ctx.notifications.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "inline-block hover:text-cebai-grey-dark",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.markAllRead && _ctx.markAllRead(...args)), ["prevent"]))
                    }, " Mark all as read ")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.notifications.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: notification.key,
                    class: _normalizeClass(["mb-3 text-sm", { 'pb-3 border-b': index !== _ctx.notifications.length - 1 }])
                  }, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["text-left", {
              'text-cebai-grey-dark cursor-default': notification.read,
              'text-cebai-base-dark hover:text-cebai-grey-dark cursor-pointer':
                !notification.read,
            }]),
                      onClick: _withModifiers(() => _ctx.markAsRead(notification._id), ["prevent"])
                    }, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(notification.summary), 1),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(notification.description), 1),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getDateOrdinal(notification.createdAt)), 1)
                    ], 10, _hoisted_12)
                  ], 2))
                }), 128))
              ])
            ], 2))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}